module.exports = __webpack_public_path__ + "img/air_state_4.3165c3ac.png";